module.exports = __webpack_public_path__ + "media/assets/images/stage-icon-fa7b1f872ff89fdf19971a543f5384c7.svg";